export default "__VITE_ASSET__B1ED2RV2__"